import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';

const Loading=(props)=>
{
    return <div className="text-center">
        {props.message&&<p className="text-center">{props.message}</p>}
        {!props.circular&&<LinearProgress />}
        {props.circular&&<CircularProgress />}
        </div>
}
export default Loading;